import React from 'react';
import { Alert, Button, Card, Container, Col, Row } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import RcSwitch from 'rc-switch';
import mainStyles from '../styles/main-panel.less';
import styles from '../styles/file-uploader.less';
import { bindingsReady } from './bindings';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('Preview');
export var PREVIEW_STATUS_INFO = 'info';
export var PREVIEW_STATUS_WARN = 'warn';
export var PREVIEW_STATUS_ERROR = 'error';
export function Preview(_ref) {
  var files = _ref.files,
    visible = _ref.visible,
    visualization = _ref.visualization,
    visualizationBindings = _ref.visualizationBindings,
    visualizationBindingsDebounced = _ref.visualizationBindingsDebounced,
    previewStatus = _ref.previewStatus,
    setPreviewStatus = _ref.setPreviewStatus,
    triggerVizUpdate = _ref.triggerVizUpdate,
    autoPreview = _ref.autoPreview,
    setAutoPreview = _ref.setAutoPreview;
  //if (!visible) {
  //    return null;
  //}

  var _bindingsReady = bindingsReady({
      files: files,
      visualizationBindings: visualizationBindings
    }),
    isReady = _bindingsReady.isReady,
    message = _bindingsReady.message;
  var url = "".concat(window.location.protocol, "//").concat(window.location.host, "/graph/graph.html?dataset=").concat(visualization.dataset_id);
  log.debug({
    visualization: visualization,
    visualizationBindings: visualizationBindings,
    visualizationBindingsDebounced: visualizationBindingsDebounced,
    previewStatus: previewStatus,
    isReady: isReady,
    message: message
  }, 'Preview');
  var isLoading = visualizationBindings && visualizationBindingsDebounced && visualizationBindings != visualizationBindingsDebounced;
  return /*#__PURE__*/_jsxs(Card, {
    className: "".concat(styles['preview'], " ").concat(mainStyles.panel),
    children: [/*#__PURE__*/_jsxs(Card.Header, {
      className: "bg-secondary text-light",
      children: [/*#__PURE__*/_jsx("i", {
        className: !isLoading ? "fa fa-eye" : "fa fa-circle-o-notch fa-spin"
      }), "Preview", /*#__PURE__*/_jsx(RcSwitch, {
        onChange: function onChange(value) {
          setAutoPreview(function () {
            return value;
          });
        },
        defaultChecked: autoPreview,
        checkedChildren: 'on',
        unCheckedChildren: 'off'
      }), /*#__PURE__*/_jsxs(Button, {
        className: "btn btn-light bg-light",
        onClick: function onClick() {
          triggerVizUpdate();
        },
        disabled: !isReady,
        children: [/*#__PURE__*/_jsx("i", {
          className: 'fa fa-clipboard'
        }), " Reload"]
      }), visualization.dataset_id ? /*#__PURE__*/_jsx(CopyToClipboard, {
        text: url,
        children: /*#__PURE__*/_jsxs("button", {
          className: "".concat(styles['copy-to-clipboard'], " btn btn-light bg-light"),
          alt: 'Copy link to clipboard',
          children: [/*#__PURE__*/_jsx("i", {
            className: 'fa fa-clipboard'
          }), " Copy visualization link"]
        })
      }) : null, !previewStatus ? null : /*#__PURE__*/_jsx(Alert, {
        className: "".concat(styles['preview-status']),
        dismissible: true,
        onClose: function onClose() {
          log.debug({
            previewStatus: previewStatus
          }, 'dismissing previewStatus');
          if (previewStatus) {
            setPreviewStatus(function () {
              return null;
            });
          }
        },
        variant: previewStatus.status === PREVIEW_STATUS_INFO ? 'secondary' : previewStatus.status === PREVIEW_STATUS_WARN ? 'warning' : previewStatus.status === PREVIEW_STATUS_ERROR ? 'danger' : 'danger',
        children: previewStatus.message
      })]
    }), /*#__PURE__*/_jsxs(Card.Body, {
      children: [!autoPreview ? 'Enable live preview to see results' : visualization.dataset_id ? null : !isReady ? /*#__PURE__*/_jsx("i", {
        children: "Live preview starts upon minimal valid configuration"
      }) : /*#__PURE__*/_jsx("i", {
        children: "Configuration Ready for preview but not yet generated"
      }), autoPreview && visualization.dataset_id ? /*#__PURE__*/_jsx("div", {
        className: "".concat(styles['preview-frame-container']),
        children: /*#__PURE__*/_jsx("iframe", {
          src: "/graph/graph.html?dataset=".concat(visualization.dataset_id, "&splashAfter=false&play=").concat(visualizationBindings.urlSettings.play),
          className: styles['preview-frame']
        })
      }) : null]
    })]
  });
}